import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loader } from '../ui/loader';

interface CustomInfiniteScrollProps {
  dataLength: number;
  fetchMore: () => void;
  hasMore: boolean;
  children: React.ReactNode;
}

const CustomInfiniteScroll: React.FC<CustomInfiniteScrollProps> = ({
  dataLength,
  fetchMore,
  hasMore,
  children,
}) => (
  <InfiniteScroll
    style={{
      overflow: 'hidden',
    }}
    dataLength={dataLength}
    pullDownToRefresh={false}
    next={fetchMore}
    hasMore={hasMore}
    endMessage={(
      <h4 className="text-center text-gray-500 py-4">
        已經到底囉 !
      </h4>
    )}
    loader={
      <div className="flex justify-center py-4">
        <Loader />
      </div>
    }
  >
    {children}
  </InfiniteScroll>
);

export default CustomInfiniteScroll;
